import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        display: 'flex',
        '& button': {
            marginRight: theme.spacing(2),
        },
    },

    buttonText: {
        fontSize: pxToRem(14),
    },
    buttonColumn: {
        '& button:hover': {
            borderColor: theme.palette.secondary.main,
        },
        '& button': {
            width: theme.spacing(10.1),
            textTransform: 'capitalize',
            height: theme.spacing(4.25),
        },
    },
}))

interface ManageProjectTeamPopupFormFooterProps {
    handleFormSubmit: VoidFunction
    handleClose: VoidFunction
    isProgress: boolean
    disableSave: boolean
    variant: 'add' | 'remove'
}
export const ManageProjectTeamPopupFormFooter: React.FC<ManageProjectTeamPopupFormFooterProps> = ({
    handleFormSubmit,
    handleClose,
    isProgress = false,
    disableSave = false,
    variant,
}) => {
    const classes = useStyles()
    const theme = useTheme()

    return (
        <GridItem
            className={clsx(classes.button, classes.buttonColumn)}
            data-testid="manageProjectTeamPopupFormFooter"
        >
            <RoundButton
                size="small"
                hasShadow={false}
                color="#FFF"
                borderColor="#fff"
                backgroundColor="#5E5F61"
                data-testid="cancelProjectTeam"
                hoverColor="#E69C24"
                onClick={handleClose}
            >
                <Typography component="span" className={classes.buttonText}>
                    CANCEL
                </Typography>
            </RoundButton>
            <RoundButton
                size="small"
                hasShadow={false}
                color="#fff"
                borderColor="#fff"
                backgroundColor={theme.palette.secondary.main}
                data-testid="saveProjectTeam"
                hoverColor="#E69C24"
                onClick={handleFormSubmit}
                loading={isProgress}
                disabled={disableSave}
            >
                <Typography component="span" className={classes.buttonText}>
                    {variant === 'add' ? 'ADD' : 'REMOVE'}
                </Typography>
            </RoundButton>
        </GridItem>
    )
}

export default ManageProjectTeamPopupFormFooter
